import {useEffect, useState, useMemo} from 'react';
import {SpanIcon} from '@mazraeapp/react_icon_kit';

interface IProps {
  type: 'success' | 'failed';
  title: string;
  timer?: number; // seconds
  onNavigateAfterTimer?: () => void;
  description: string;
  tracingCode?: string;
  buttonText: string;
  buttonOnClick: () => void;
}

const PaymentReceipt = ({
  type,
  title,
  timer = 5,
  onNavigateAfterTimer,
  description,
  buttonText,
  buttonOnClick,
}: IProps) => {
  const [count, setCount] = useState(timer);

  // Count down
  useEffect(() => {
    const intervalId = setInterval(() => {
      setCount(prev => {
        if (prev === 1) {
          clearInterval(intervalId);
          onNavigateAfterTimer?.();
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(intervalId);
  }, [onNavigateAfterTimer]);

  const statusColor = useMemo(() => {
    return type === 'success' ? 'green' : 'red';
  }, [type]);

  return (
    <div className="flex flex-col items-center justify-center h-screen px-14">
      <SpanIcon
        className={`icon-nameCheck-circle1 text-${statusColor}-500 text-6xl`}
      />
      <h2 className={`text-${statusColor}-500 text-lg mt-3`}>{title}</h2>
      <div className={`my-6 text-${statusColor}-500`}>{count}</div>
      <p className="text-md text-gray-900 mb-7 text-justify">{description}</p>
      <button
        onClick={buttonOnClick}
        className="bg-green-500 text-white rounded-md px-8 py-2 text-md w-full border-none"
      >
        {buttonText}
      </button>
    </div>
  );
};

export default PaymentReceipt;
